import React, { useState, useRef } from 'react';

import ProfileCard from './ProfileCard';
import MatchedProfilePopup from '../../../components/MatchedProfile/MatchedProfilePopup';

import config from '../../../../config';
import links from '../../../../config/links';

import styles from '../nuoV2.scss';

const MatchingProfiles = (props) => {
    const { userIsPowered, matchedProfiles, submitting, manualSearch } = props;
    const { profiles, isLoading, isLoaded } = matchedProfiles;

    const [state, setState] = useState({
        showPopup: false,
        popupTitle: null,
        popupDescription: null,
        showPopupContinue: false,
        selectedProfileData: null,
        popUpTop: null,
        submitting: true,
    });
    const relativeDiv = useRef();

    const onProfileSelect = (profileData, e) => {
        const { claimed, firstName, lastName, obfuscatedEmail } = profileData;
        const topValue = e.target.getBoundingClientRect().top - relativeDiv.current?.getBoundingClientRect()?.top;
        let title = `Activate ${firstName} ${lastName}`;
        let description = `<ul>
                            <li>You confirm that you are ${firstName} ${lastName} or the parent/guardian of ${firstName} ${lastName}. If you knowingly activate someone else's profile without the legal authority to do so, you will be subject to losing all access to UTR Sports and further penalties as per our <a href=${`${config.marketingAppHost}/tos`} target="_blank">terms of service</a>.</li>
                            <li>If you see multiple player profiles that are you, activate one and then contact our <a href="https://support.${config.siteBaseUrl}/support/tickets/new" target="_blank">support team</a> to merge the other profiles.</li>
                        </ul>`;
        let showConfirm = true;

        if (claimed) {
            title = 'Profile already activated';
            description = `<ul>
                                <li>It looks like this player profile has been activated by a user with the email address: ${obfuscatedEmail}.</li>
                                <li>If this email address looks familiar, <a href="${config.appHost}/login" target="_blank">click here</a> to log in or <a href="${config.appHost}/forgotpassword" target="_blank">click here</a> to reset your password.</li>
                                <li>If this email address does not look familiar, please <a href=${links.support} target="_blank">click here</a> to contact customer support</li>
                           </ul>`;
            showConfirm = false;
        }

        setState(prevState => ({
            ...prevState,
            showPopup: true,
            popupTitle: title,
            popupDescription: description,
            showPopupContinue: showConfirm,
            selectedProfileData: profileData,
            popUpTop: e ? topValue : null,
        }));
    };

    const onPopupClose = () => {
        setState(prevState => ({
            ...prevState,
            showPopup: false,
            popupTitle: null,
            popupDescription: null,
            showPopupContinue: false,
            selectedProfileData: null,
            popUpTop: null,
        }));
    };

    const onPopupContinue = () => {
        setState(prevState => ({
            ...prevState,
            submitting: false,
        }));
        props.onProfileSelect(state.selectedProfileData);
        onPopupClose();
    };

    if (isLoading || (!isLoading && !isLoaded)) {
        return (
            <div>
                <div className={styles.description} data-testid="nuo-v2.matching-profiles.loading">Searching...</div>
            </div>
        );
    }

    return (
        <div
            className={``}
            ref={relativeDiv}
        >
            {isLoaded && !!profiles?.length && (
                <div>
                    {!manualSearch && (
                        <div className={styles.description} data-testid="nuo-v2.matching-profiles.found-description">
                            We’ve found the following results in our system that may be yours. Are any of these you?
                        </div>
                    )}
                    {profiles.map((profile) => {
                        return (
                            <div key={`matched-profile-${profile.id}`}>
                                <ProfileCard
                                    {...profile}
                                    userIsPowered={userIsPowered}
                                    onProfileSelect={onProfileSelect}
                                    disabled={submitting}
                                />
                            </div>
                        );
                    })}
                    <div className={styles.description} data-testid="nuo-v2.matching-profiles.not-you-description">
                        <div className="fw500 mb8">NOT YOU?</div>
                            You can search by a different name if you’d like to see if we have any other results for you. If not,
                            please click "continue".
                    </div>
                </div>
            )}
            {isLoaded && profiles && !profiles.length && (
                <>
                    <div className={styles.description} data-testid="nuo-v2.matching-profiles.no-results-description">
                        Based on your name, we did not find any matching profiles in our system.
                    </div>
                    <div className={styles.description}>
                        Feel free to search for an alternate spelling of your name, or create a new profile below.
                    </div>
                </>
            )}
            {state.showPopup ? (
                <MatchedProfilePopup
                    title={state.popupTitle}
                    description={state.popupDescription}
                    closePopup={onPopupClose}
                    showPopupContinue={state.showPopupContinue}
                    confirmPopup={onPopupContinue}
                    topPoint={state.popUpTop}
                />
            ) : null}
        </div>
    );
};

export default MatchingProfiles;
